import { useEffect, type RefObject } from 'react'

/**
 * Close-on-outside-click for menus, popovers and drawers.
 *
 * Bound on `pointerdown`, not `click`: a `click` listener fires after the
 * button that opened the panel has already toggled it, which makes a trigger
 * inside the same subtree close and immediately reopen.
 */
export function useClickOutside<T extends HTMLElement>(
  ref: RefObject<T>,
  onOutside: () => void,
  enabled = true,
) {
  useEffect(() => {
    if (!enabled) return
    const handler = (event: PointerEvent) => {
      const node = ref.current
      if (node && !node.contains(event.target as Node)) onOutside()
    }
    document.addEventListener('pointerdown', handler)
    return () => document.removeEventListener('pointerdown', handler)
  }, [ref, onOutside, enabled])
}
